import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-6 md:px-10 py-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          {/* Left: Brand + Image */}
          <div className="lg:w-5/12">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">Superbuy Spread</span>
            </div>
            <img
              src="https://readdy.ai/api/search-image?query=Lifestyle%20product%20photography%20scene%20with%20fashion%20accessories%20on%20cream%20textured%20surface%2C%20soft%20natural%20lighting%20through%20window%2C%20minimalist%20interior%20styling%2C%20warm%20neutral%20tones%2C%20editorial%20aesthetic%2C%20clean%20composition%2C%20gentle%20shadows%2C%20cozy%20modern%20home%20vibe&width=500&height=400&seq=footer-lifestyle-01&orientation=squarish"
              alt="Superbuy Spreadsheet lifestyle product scene"
              title="Superbuy Spreadsheet product resources"
              className="rounded-lg w-full max-w-sm object-cover"
            />
          </div>

          {/* Right: Navigation columns */}
          <div className="lg:w-7/12 grid grid-cols-2 sm:grid-cols-4 gap-8">
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Navigate</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Home</Link>
                <Link to="/#categories" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Categories</Link>
                <Link to="/#about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">About</Link>
                <Link to="/superbuy-spreadsheet-complete-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Guide</Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Popular</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Shoes</a>
                <a href="https://kaspreadsheet.com/search-912/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Hoodies</a>
                <a href="https://kaspreadsheet.com/search-913/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">T-Shirts</a>
                <a href="https://kaspreadsheet.com/search-921/name/Shoes.html" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Bags</a>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Resources</h4>
              <div className="flex flex-col gap-2.5">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">Main Site</a>
                <Link to="/superbuy-spreadsheet-complete-guide" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">SEO Guide</Link>
                <Link to="/#faq" className="text-sm text-background-50/60 hover:text-background-50 transition-colors">FAQ</Link>
              </div>
            </div>
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">Legal</h4>
              <div className="flex flex-col gap-2.5">
                <p className="text-sm text-background-50/60">&copy; 2026 Superbuy Spread</p>
                <p className="text-xs text-background-50/40 font-serif italic">All rights reserved</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            Superbuy Spread is an independent resource hub. We are not affiliated with Superbuy.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-50/50 hover:text-background-50 transition-colors underline">
              Visit Main Website
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}